<p-toast position="top-right" />
<app-update-notification />
<router-outlet />
<kl-global-loader />

<div id="sentry-debug" class="d-none position-absolute top-0 start-0">
  <button class="btn btn-primary" (click)="testSentry()">Test Sentry</button>
</div>
